<template>
	<div class="bg5 r2 b1 bc7 p4">
		<slot></slot>

		<!-- Limit of Liability -->
		<div class="xs-12 flex xs-middle">
			<!-- Value -->
			<div class="xs-10">
				<div class="fw7 mb1">Limit of Liability</div>
				<j-base-input-number
					name="product_liability"
					v-model="form.product_liability"
					v-validate="{ min_value: 10000, max_value: 10000000 }"
					@blur="addOtherBenefitOptons('product_liability')"
				/>
				<span
					v-if="errors.has('product_liability')"
					class="xs-12 fs3 lh125 cError mt1"
					>This field value range from 10000 to 10000000</span
				>
			</div>
			<!-- Currency -->
			<div class="xs-2 pl2 pt4">
				{{ currency }}
			</div>
		</div>

		<!-- Deductible USA/CANADA -->
		<div class="xs-12 flex xs-middle mt6">
			<!-- Value -->
			<div class="xs-10">
				<div class="fw7 mb1">Deductible North America</div>
				<j-base-input-number
					v-model="form.deductible_north_america"
					@blur="addOtherBenefitOptons('deductible_north_america')"
				/>
			</div>

			<!-- Currency -->
			<div class="xs-2 pl2 pt4">
				{{ currency }}
			</div>
		</div>

		<!-- Deductible ROW -->
		<div class="xs-12 flex xs-middle mt6">
			<!-- Value -->
			<div class="xs-10">
				<div class="fw7 mb1">Deductible Rest of The World</div>
				<j-base-input-number
					v-model="form.deductible_rest_of_the_world"
					@blur="addOtherBenefitOptons('deductible_rest_of_the_world')"
				/>
			</div>

			<!-- Currency -->
			<div class="xs-2 pl2 pt4">
				{{ currency }}
			</div>
		</div>

		<!-- Endorsements -->
		<div class="fw7 mb2 mt6">Endorsements</div>
		<!-- List of added endorsements -->
		<div class="xs-12">
			<div v-for="benefitOption in endorsements" class="r2 p3 bg4 b1 bc7 mb2">
				<div class="lh125 fw7">{{ benefitOption.name }}</div>
				<div class="lh125">
					{{ benefitOption.value ? benefitOption.value.numberValue : "0" }}
					{{ currency }}
				</div>
				<div
					class="mt2 cError cu2 fw7 fs3 tt2"
					@click="removeBenefitOption(benefitOption.benefitTypeId)"
				>
					Remove
				</div>
			</div>
		</div>

		<!-- <pre>
		{{ benefitOptions }}
		</pre
		> -->

		<!-- Add Buttons -->
		<div class="flex mt4">
			<j-button
				v-if="!hasRecallExpensesExtension"
				size="xsmall"
				type="bordered"
				class="mr2"
				@click="openModal('recall_expenses_extension')"
			>
				Add Recall Expenses Extension Endorsement
			</j-button>
			<j-button
				v-if="!hasManufacturersErrors"
				size="xsmall"
				type="bordered"
				@click="openModal('manufacturers_errors_and_omissions_extension')"
			>
				Add Manufacturers E&O Extension Endorsement
			</j-button>
		</div>

		<!-- Add modal -->
		<core-modal name="endorsementAdd" :headline="$t('add')">
			<div class="p4">
				<div class="fw7 mb1">Set sub-limit</div>
				<j-base-input-number v-model="form.sublimit" />
				<j-button
					@click="addEndorsement(endorsementTypeIdToAdd, form.sublimit)"
					class="mt6"
				>
					Add
				</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputNumber from "@/components/JBaseInputNumber"
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import JButton from "@/components/JButton"
import CaseForm from "../CaseForm/CaseForm.vue"
import CoreModal from "@/modules/core/components/CoreModal"
import ProductsLiabilityBenefitsCustom from "./ProductsLiabilityBenefitsCustom"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JBaseInputText,
		JBaseInputNumber,
		JBaseMultiSelectWithFlexibleValue,
		JButton,
		CaseForm,
		CoreModal,
		ProductsLiabilityBenefitsCustom
	},

	data() {
		return {
			form: {
				product_liability: 10000,
				deductible_north_america: 0,
				deductible_rest_of_the_world: 0,

				// For endorsements
				sublimit: 0
			},

			// When adding endorsements
			endorsementTypeIdToAdd: "",
			options: {
				endorsements: [
					{
						name: "Recall Expenses Extension Endorsement",
						value: "Recall Expenses Extension Endorsement"
					},
					{
						name: "Manufacturers E&O Extension Endorsement",
						value: "Manufacturers E&O Extension Endorsement"
					}
				]
			}
		}
	},

	computed: {
		// Find currency in store based on case fact
		currency() {
			return (
				this.$store.state.caseManagement.case?.facts?.find(
					fact => fact.type === "currency"
				)?.value?.stringValue || ""
			)
		},

		benefitOptions() {
			const { proposalId, offerId } = this.$store.state.caseManagement
			const offer = this.$store.state.caseManagement?.proposals
				?.find(proposal => proposal.id === proposalId)
				?.basket?.find(offer => offer.id === offerId)

			return offer?.benefitOptions || []
		},

		endorsements() {
			return this.benefitOptions?.filter(
				item =>
					item.benefitTypeId === "recall_expenses_extension" ||
					item.benefitTypeId === "manufacturers_errors_and_omissions_extension"
			)
		},

		otherBenefitOptions() {
			return this.benefitOptions?.filter(
				item =>
					item.benefitTypeId !== "recall_expenses_extension" &&
					item.benefitTypeId !== "manufacturers_errors_and_omissions_extension"
			)
		},

		hasRecallExpensesExtension() {
			return this.benefitOptions?.find(
				benefitOption =>
					benefitOption.benefitTypeId === "recall_expenses_extension"
			)
				? true
				: false
		},

		hasManufacturersErrors() {
			return this.benefitOptions?.find(
				benefitOption =>
					benefitOption.benefitTypeId ===
					"manufacturers_errors_and_omissions_extension"
			)
				? true
				: false
		}
	},

	methods: {
		openModal(typeId) {
			this.endorsementTypeIdToAdd = typeId
			this.$modal.show("endorsementAdd")
		},

		async addEndorsement() {
			// 1: Upsert benefit option
			this.upsertBenefitOption(this.endorsementTypeIdToAdd, this.form.sublimit)

			//2: Add loading
			const loadingAdded = await this.addLoadingToProposalOffer()

			// Refetch store to update data
			await this.refetchStore()

			// Close popup and reset form
			this.form.sublimit = 0
			this.endorsementTypeIdToAdd = ""
			this.$modal.hide("endorsementAdd")
		},

		async addOtherBenefitOptons(typeId) {
			await this.upsertBenefitOption(typeId, this.form[typeId])

			// Refetch store to update data
			await this.refetchStore()
		},

		async upsertBenefitOption(typeId, value) {
			const query = gql`
				mutation upsertBenefitOptionOfProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: benefitOptionInput!
				) {
					upsertBenefitOptionOfProposalOffer(
						caseId: $caseId
						offerId: $offerId
						proposalId: $proposalId
						input: $input
					) {
						status
						errors
					}
				}
			`

			const { caseId, proposalId, offerId } = this.$store.state.caseManagement
			const res = await api({
				query,
				variables: {
					caseId,
					proposalId,
					offerId,
					input: {
						typeId,
						value: {
							numberValue: value
						}
					}
				}
			})

			// Errors
			if (res?.data?.upsertBenefitOptionOfProposalOffer?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.upsertBenefitOptionOfProposalOffer?.errors ||
						this.$t("errors.general")
				)
				return Promise.resolve()
			}

			return Promise.resolve()
		},

		async removeBenefitOption(typeId) {
			const query = gql`
				mutation removeBenefitOptionFromProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$typeId: String!
				) {
					removeBenefitOptionFromProposalOffer(
						caseId: $caseId
						offerId: $offerId
						proposalId: $proposalId
						typeId: $typeId
					) {
						status
						errors
					}
				}
			`

			const { caseId, proposalId, offerId } = this.$store.state.caseManagement
			const res = await api({
				query,
				variables: {
					caseId,
					proposalId,
					offerId,
					typeId
				}
			})

			// Errors
			if (
				res?.data?.removeBenefitOptionFromProposalOffer?.status !== "success"
			) {
				this.$store.dispatch(
					"showError",
					res?.data?.removeBenefitOptionFromProposalOffer?.errors ||
						this.$t("errors.general")
				)
				return
			}

			// Success refetch
			this.refetchStore()
		},

		async addLoadingToProposalOffer() {
			const query = gql`
				mutation addLoadingToProposalOffer(
					$caseId: String!
					$proposalId: String!
					$offerId: String!
					$input: loadingInput!
				) {
					addLoadingToProposalOffer(
						caseId: $caseId
						proposalId: $proposalId
						offerId: $offerId
						input: $input
					) {
						errors
						status
					}
				}
			`

			let code
			let ratio

			if (this.endorsementTypeIdToAdd === "recall_expenses_extension") {
				code = "product_liability|product_recall_expenses"
				ratio = 0.15
			} else {
				code = "product_liability|errors_and_omissions"
				ratio = 0.2
			}

			const { caseId, proposalId, offerId } = this.$store.state.caseManagement
			const variables = {
				caseId,
				proposalId,
				offerId,
				input: {
					code,
					ratio,
					order: 0
				}
			}

			const res = await api({ query, variables })

			// Errors
			if (res?.data?.addLoadingToProposalOffer?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.addLoadingToProposalOffer?.errors ||
						this.$t("errors.general")
				)
				return Promise.resolve(res)
			}

			return Promise.resolve(res)
		},

		async refetchStore() {
			const caseCurrencyCode = this.$store.state.caseManagement.case?.facts?.find(
				fact => fact.type === "premiumCurrency"
			)?.value?.stringValue

			await this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId,
				options: { currencyCodes: [caseCurrencyCode] }
			})

			return Promise.resolve()
		}
	},

	watch: {
		// When benefits update, update internal state of the form
		// Especialy important when we init the form
		otherBenefitOptions: {
			handler(newValue, oldValue) {
				const newForm = {}

				newValue.forEach(
					item => (newForm[item.benefitTypeId] = item?.value?.numberValue)
				)

				console.log(newForm)

				this.form = { ...this.form, ...newForm }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
